import _ from '@lodash';
import { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import axios from "@fuse/utils/axios";
import { AgGridReact } from 'ag-grid-react';
import '../../../../../../../../styles/ag-custom.css';

import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-material.css';
import 'styles/ag-grid-header-style.css';

const useStyles = makeStyles({
    layoutRoot: {},
    head: {
        position: "sticky",
        top: 0
    },
    root: {
        // minWidth: 275,
    },
    title: {
        fontSize: 14,
    },
    pos: {
        marginBottom: 12,
    },
});

function setHeaderName(header) {
    if (header === 'company_id') {
        return 'Company ID'
    } 
        return header.split('_').map(word => word.charAt(0).toUpperCase() + word.substring(1)).join(' ')
    
}

function getHeaderName(header) {

    const isObject = typeof header === "object";

    if (!isObject) return setHeaderName(header);

    return header.label ? header.label : ""
}

function getFieldName(header) {

    const isObject = typeof header === "object";

    if (!isObject) return header;

    return header.field ? header.field : ""
}

function ListView(props) {
    const classes = useStyles();

    const { rows, onRowClicked, columns, table_name } = props;

    const columnHeaders = columns || Object.keys(rows[0]);

    const[ windowHeight, setWindowHeight] = useState(window.innerHeight - 100)

    function onGridReady (params){
        loadInitialState(params);
    }

    function onGridSizeChanged(){
        setWindowHeight(window.innerHeight - 180)
    }

    function onFilterChanged(event){
		// validation for no-overlay 
		const total_rows = event.api.getDisplayedRowCount();
		if(total_rows === 0 ){
			event.api.showNoRowsOverlay();
		}else{
			event.api.hideOverlay();
		}
	}

    function loadInitialState (params){
        if(!table_name) return;
        axios.get(`/user-view/show-view-order?table_name=${table_name}`)
        .then(results=>{
            const { data } = results.data;
            const order = JSON.parse(data.order);
            params.api.applyColumnState(order);
        })
        .catch(err=>{
            console.log(err);
        })
    }

    
    function saveView(rows){
        if(!table_name) return;
        const order = JSON.stringify(rows);
        axios.post('/user-view/save-view-order',{
            table_name,
            order
        })
        .then(results=>{
            console.log('view updated');
        })
        .catch(err=>{
            console.log(err);
        })
    }


    function onColumnMoved (params) {
        const rows = params.api.getColumnState();
        saveView(rows);
    }

    function onColumnVisible(params){
		const rows = params.api.getColumnState();
		const total_no_of_columns = rows.length;
		let total_hidden_columns = 0;
		rows.forEach(row=>{
			const { hide } = row;
			if(hide) {
				++total_hidden_columns;
			}
		});
		if( total_hidden_columns < total_no_of_columns){
				saveView(params.api.getColumnState());
		}
	}

    return (
        <div className="ag-theme-material" style={{ height: windowHeight, width: "100%" }}>
            <AgGridReact
                onGridReady = { onGridReady }
                suppressDragLeaveHidesColumns
                // domLayout={'autoHeight'}
                onGridSizeChanged={onGridSizeChanged}
                rowData={rows}
                overlayNoRowsTemplate='<span style="text-align: center">No rows found</span>'
				onFilterChanged = { onFilterChanged }	

                onColumnMoved = { onColumnMoved }

                onColumnVisible={onColumnVisible}
                columnDefs={columnHeaders.map((header) => {

                    const cellRendererFrameworkProps = header.cellRendererFramework ? {
                        cellRendererFramework (params){
                           return header.cellRendererFramework(params, params.node.data[header.field])
                        }
                    } : {};

                    const cellClickedProps = {
                        onCellClicked (params){
                            typeof header.cellClicked === "function"
                            ? header.cellClicked(params, params.node.value) 
                            : typeof onRowClicked === "function" && onRowClicked(params, params.node.value)
                        },
                    }
                    
                    return {
                        key: `${header}1`,
                        field: getFieldName(header),
                        headerName: getHeaderName(header),
                        sortable: true,
                        floatingFilter: true,
                        enableCellTextSelection: true,
                        ensureDomOrder: true,
                        ...cellRendererFrameworkProps,
                        ...cellClickedProps,
                        filter: "agTextColumnFilter"
                    }
                })}
                 />
        </div>
    );
}

export default ListView
